import appInstanceConst from '@/consts/appInstance.const.js';

const countryCodes = [
  { numericCode: 826, alphaTwoCode: 'GB', alphaThreeCode: 'GBR', instance: appInstanceConst.UK, motherCountry: true },
  { numericCode: 238, alphaTwoCode: 'FK', alphaThreeCode: 'FLK', instance: appInstanceConst.UK, motherCountry: false },
  { numericCode: 831, alphaTwoCode: 'GG', alphaThreeCode: 'GGY', instance: appInstanceConst.UK, motherCountry: false },
  { numericCode: 832, alphaTwoCode: 'JE', alphaThreeCode: 'JEY', instance: appInstanceConst.UK, motherCountry: false },
  { numericCode: 833, alphaTwoCode: 'IM', alphaThreeCode: 'IMN', instance: appInstanceConst.UK, motherCountry: false },

  { numericCode: 840, alphaTwoCode: 'US', alphaThreeCode: 'USA', instance: appInstanceConst.US, motherCountry: true },

  { numericCode: 124, alphaTwoCode: 'CA', alphaThreeCode: 'CAN', instance: appInstanceConst.CA, motherCountry: true },
];

/**
 * @returns the numeric code of the mother country related with a given instance.
 */
const getMotherCountryCodeByInstance = (instance) => {
  return countryCodes.find(({ instance: eachInstance, motherCountry }) => eachInstance === instance && motherCountry)?.numericCode;
};

/**
 * @returns an array containing the country codes related with a given instance.
 */
const getNumericCodesByInstance = (instance) => {
  return countryCodes.filter(({ instance: eachInstance }) => eachInstance === instance).map(({ numericCode }) => numericCode);
};

/**
 * @returns an array containing the alpha-2 codes related with a given instance.
 */
const getAlphaTwoCodesByInstance = (instance) => {
  return countryCodes.filter(({ instance: eachInstance }) => eachInstance === instance).map(({ alphaTwoCode }) => alphaTwoCode);
};

/**
 * @returns an array containing the alpha-3 codes related with a given instance.
 */
const getAlphaThreeCodesByInstance = (instance) => {
  return countryCodes.filter(({ instance: eachInstance }) => eachInstance === instance).map(({ alphaThreeCode }) => alphaThreeCode);
};

/**
 * @returns the numeric code related with a given alpha two code
 */
const getNumericCodeByAlphaTwoCode = (alphaTwoCode) => {
  return countryCodes.find(({ alphaTwoCode: eachAlphaTwoCode }) => eachAlphaTwoCode.toLowerCase() === alphaTwoCode.toLowerCase())?.numericCode;
};

export default {
  getMotherCountryCodeByInstance,
  getNumericCodesByInstance,
  getAlphaTwoCodesByInstance,
  getAlphaThreeCodesByInstance,
  getNumericCodeByAlphaTwoCode,
};
